import Translate from "../../../components/Translate";
import {Link} from "react-router-dom";
import React, {Fragment} from "react";

export default function MenuSoci({
                                     isRuoloAdmin,
                                     isRuoloSegreteria,
                                     isRuoloClub,
                                     isRuoloAgenzia,
                                 }) {

    return (isRuoloAdmin() || isRuoloSegreteria()) ?
        <li className="nav-item dropdown">
            <a className="nav-link dropdown-toggle" href="#" id="utenti-menu"
               role="button"
               data-bs-toggle="dropdown" aria-expanded="false">
                <i className="fas fa-user"/> <Translate>Soci</Translate>
            </a>
            <ul className="dropdown-menu" aria-labelledby="utenti-menu">
                <li>
                    <Link to="/list-persone" className="dropdown-item">
                        <div data-bs-toggle="collapse"
                             data-bs-target=".navbar-collapse.show">
                            <i className="fas fa-users"/>
                            <Translate>Archivio Soci</Translate>
                        </div>
                    </Link>
                </li>
                <li>
                    <hr className="dropdown-divider"/>
                </li>
                <li>
                    <Link to="/list-nuovi-soci" className="dropdown-item">
                        <div data-bs-toggle="collapse"
                             data-bs-target=".navbar-collapse.show">
                            <i className="fas fa-folder-plus"/>
                            <Translate>Nuove registrazioni</Translate>
                        </div>
                    </Link>
                </li>
                <li>
                    <Link to="/list-quote-temp" className="dropdown-item">
                        <div data-bs-toggle="collapse"
                             data-bs-target=".navbar-collapse.show">
                            <i className="fas fa-credit-card"/>
                            <Translate>Quote da approvare</Translate>
                        </div>
                    </Link>
                </li>
                <li>
                    <Link to="/list-quote-asi" className="dropdown-item">
                        <div data-bs-toggle="collapse"
                             data-bs-target=".navbar-collapse.show">
                            <i className="fas fa-credit-card"/>
                            <Translate>Quote ASI da versare</Translate>
                        </div>
                    </Link>
                </li>
                {
                    !isRuoloClub() && !isRuoloAgenzia() &&
                    <Fragment>
                        <li>
                            <Link to="/stampe-fine-giornata"
                                  className="dropdown-item">
                                <div data-bs-toggle="collapse"
                                     data-bs-target=".navbar-collapse.show">
                                    <i className="fas fa-print"/>
                                    <Translate>Stampe di fine
                                        giornata</Translate>
                                </div>
                            </Link>
                        </li>
                        <li>
                            <hr className="dropdown-divider"/>
                        </li>
                        <li>
                            <Link to="/cruscotto-rfi" className="dropdown-item">
                                <div data-bs-toggle="collapse"
                                     data-bs-target=".navbar-collapse.show">
                                    <i className="fas fa-chart-bar"/>
                                    <Translate>Cruscotto RFI</Translate>
                                </div>
                            </Link>
                        </li>
                        <li>
                            <Link to="/cruscotto-abarth"
                                  className="dropdown-item">
                                <div data-bs-toggle="collapse"
                                     data-bs-target=".navbar-collapse.show">
                                    <i className="fas fa-chart-bar"/>
                                    <Translate>Cruscotto ABARTH</Translate>
                                </div>
                            </Link>
                        </li>
                    </Fragment>
                }
            </ul>
        </li>
        :
        (isRuoloClub() || isRuoloAgenzia()) &&
        <Fragment>
            <li className="nav-item">
                <Link className="nav-link" aria-current="page"
                      to="/list-persone">
                    <div data-bs-toggle="collapse"
                         data-bs-target=".navbar-collapse.show">
                        <i className="fas fa-users"/> Soci
                    </div>
                </Link>
            </li>
        </Fragment>
}